export default function($) {
  $(function() {
    if ($('#subject').val() == 'Projet piscine'){
      $('.js-budget').show();
      $('.js-use').show();
      $('.js-location').show();
      $('.js-size').show();
    }
    else{
      $('.js-budget').hide();
      $('.js-use').hide();
      $('.js-location').hide();
      $('.js-size').hide();
    }
  });
  $('#subject').on('change', function() {
    if ($(this).val() == 'Projet piscine'){
      $('.js-budget').show();
      $('.js-use').show();
      $('.js-location').show();
      $('.js-size').show();
    }
    else if ($('#subject').val() == 'Projet bien-être'){
      $('.js-budget').show();
      $('.js-use').show();
      $('.js-location').show();
      $('.js-size').hide();
    }
    else{
      $('.js-budget').hide();
      $('.js-use').hide();
      $('.js-location').hide();
      $('.js-size').hide();
    }
  });
}
